var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatternPhotography(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EB7565",
    d: "M32 0h64v64H32z"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#030303",
    strokeWidth: 4,
    cx: 16,
    cy: 16,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF7F0",
    strokeWidth: 4,
    cx: 64,
    cy: 32,
    r: 14
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#030303"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128 32h4v4h-4zM142 32h4v4h-4zM156 32h4v4h-4zM128 56h4v4h-4zM142 56h4v4h-4zM156 56h4v4h-4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M128 60h4v4h-4zM142 60h4v4h-4zM156 60h4v4h-4z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#030303"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128 0h4v4h-4zM142 0h4v4h-4zM156 0h4v4h-4zM128 4h4v4h-4zM142 4h4v4h-4zM156 4h4v4h-4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M128 28h4v4h-4zM142 28h4v4h-4zM156 28h4v4h-4z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF7F0",
    d: "m96 32 32 32V32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#552049",
    d: "m96 32 32 32V32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F39E9E",
    d: "M32 64 0 32v32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF7F0",
    d: "m96 32 32-32v32z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternPhotography);
export default __webpack_public_path__ + "static/media/pattern-photography.41af493d4ba2f69b230266ac6a9184c9.svg";
export { ForwardRef as ReactComponent };